/**
 * Labstep
 *
 * @module prosemirror/components/NodeView/Conditions
 * @desc Renders an Conditions node
 */

import { ProtocolConditionProtocolValueVariableSmartTable } from 'labstep-web/components/ProtocolCondition/ProtocolValueVariableSmartTable';
import { GridSmartTableProtocolConditionService } from 'labstep-web/grid/SmartTableProtocolCondition/services/grid-smart-table-protocol-condition.service';
import type { Entity } from 'labstep-web/models/entity.model';
import type { Protocol } from 'labstep-web/models/protocol.model';
import { Read } from 'labstep-web/prosemirror/components/NodeView/Read';
import React from 'react';
import type { IConditionsNodeProps } from './types';

export const agGridProseMirrorClass = 'ag-grid-prosemirror';

export class ConditionsNode extends React.Component<IConditionsNodeProps> {
  public shouldComponentUpdate(): boolean {
    return false;
  }

  public render(): JSX.Element {
    const { entity, timestamp } = this.props;
    return (
      <Read
        entityName={entity.entityName}
        id={entity.id}
        timestamp={timestamp}
      >
        {({ entity: protocol }: { entity: Entity }): JSX.Element => {
          const props: any = {
            protocol: protocol as Protocol,
            initialExpandedState: true,
            gridProps: {
              className: agGridProseMirrorClass,
              defaultColDef: { resizable: false },
            },
          };
          if (timestamp) {
            props.gridProps = {
              ...props.gridProps,
              editable: false,
              params: { at: timestamp },
            };
          }
          return (
            <div contentEditable={false}>
              <ProtocolConditionProtocolValueVariableSmartTable
                protocol={protocol as Protocol}
                variableTemplate={undefined}
                defaultColIds={GridSmartTableProtocolConditionService.getLegacyConditionTableColIds(
                  protocol as Protocol,
                )}
                name={'Conditions Table'}
              />
            </div>
          );
        }}
      </Read>
    );
  }
}
